import { AtSignIcon, EmptyState } from '@buffer-mono/popcorn'

import { ConnectSupportedChannelsCard } from '~publish/pages/Community/components/EmptyStates/ConnectSupportedChannelsCard'
import { FeedRow } from '~publish/pages/Community/components/FeedRow'

import {
  MENTIONS_CHANNEL_OPTIONS,
  MENTIONS_COMING_SOON_SERVICES,
} from './mentionsChannelOptions'

import styles from './MentionsNotSupportedEmptyState.module.css'

import type { JSX } from 'react'

/**
 * Shown in the mentions inbox when none of the channels in scope can surface
 * mentions. The tab is present on every channel, so without this the inbox
 * would read as "no mentions yet" and imply Buffer is listening for mentions it
 * will never receive.
 */
export const MentionsNotSupportedEmptyState = (): JSX.Element => (
  <FeedRow>
    <div className={styles.container}>
      <EmptyState size="large">
        <EmptyState.Icon>
          <AtSignIcon />
        </EmptyState.Icon>
        <EmptyState.Heading>
          Mentions are available only for selected channels
        </EmptyState.Heading>
        <EmptyState.Description>
          We&apos;re actively working on expanding this list.
        </EmptyState.Description>
      </EmptyState>
      <ConnectSupportedChannelsCard
        hint="Connect one of the supported channels to see mentions."
        options={MENTIONS_CHANNEL_OPTIONS}
        comingSoonServices={MENTIONS_COMING_SOON_SERVICES}
        cta="publish-mentions-emptyState-connectChannel-1"
      />
    </div>
  </FeedRow>
)
